import { API } from 'aws-amplify';
import { API_NAME, getConfig, validateResponse, handleError } from './apiUtils';

// country api
export async function getCountry(country) {
    const path = `/v1/nbaadmin/${country}/nba-country`;

    return getConfig()
        .then((config) => API.get(API_NAME, path, config))
        .then(validateResponse)
        .catch(handleError);
}
export async function createCountry(countryCode, countryName) {
    const path = `/v1/nbaadmin/${countryCode}/nba-country`;

    return getConfig({ countryName })
        .then((config) => API.post(API_NAME, path, config))
        .then(validateResponse)
        .catch(handleError);
}

// entity attribute api
export async function getEntityAttribute(country, brand) {
    const path = `/v1/zerocopycdp/${country}/${brand}/nba-entity-attribute`;

    return getConfig()
        .then((config) => API.get(API_NAME, path, config))
        .then(validateResponse)
        .catch(handleError);
}

// action list
export async function getActionList(country) {
    const path = `/v1/nbaadmin/${country}/nba-action`;

    return getConfig()
        .then((config) => API.get(API_NAME, path, config))
        .then(validateResponse)
        .catch(handleError);
}

// rules
export async function createRule(country, brand, body) {
    const path = `/v1/zerocopycdp/${country}/${brand}/rule`;

    return getConfig(body)
        .then((config) => API.post(API_NAME, path, config))
        .then(validateResponse)
        .catch(handleError);
}

// Mannual triggerrules
export async function mannualTriggerRule(country, brand, body) {
    const path = `/v1/zerocopycdp/${country}/${brand}/manual-test`;

    return getConfig(body)
        .then((config) => API.post(API_NAME, path, config))
        .then(validateResponse)
        .catch(handleError);
}

export async function getRule(country, brand, ruleId) {
    const path = `/v1/zerocopycdp/${country}/${brand}/rule/${ruleId}`;

    return getConfig()
        .then((config) => API.get(API_NAME, path, config))
        .then(validateResponse)
        .catch(handleError);
}
export async function getTenant(country, brand, ruleId) {
    const path = `/v1/zerocopycdp/tenant`;

    return getConfig()
        .then((config) => API.get(API_NAME, path, config))
        .then(validateResponse)
        .catch(handleError);
}
export async function getRuleRunHistory(country, brand, ruleId) {
    const path = `/v1/zerocopycdp/${country}/${brand}/schedule-history/${ruleId}`;

    return getConfig()
        .then((config) => API.get(API_NAME, path, config))
        .then(validateResponse)
        .catch(handleError);
}
export async function getRuleList(country, brand) {
    const path = `/v1/zerocopycdp/${country}/${brand}/rule`;

    return getConfig()
        .then((config) => API.get(API_NAME, path, config))
        .then(validateResponse)
        .catch(handleError);
}
// export async function updateRule(country, ruleId, body) {
//     const path = `/v1/nbaadmin/${country}/rule/${ruleId}`;

//     return getConfig(body)
//         .then((config) => API.put(API_NAME, path, config))
//         .then(validateResponse)
//         .catch(handleError);
// }

export async function updateRule(country, brand, ruleId, body) {
    const path = `/v1/zerocopycdp/${country}/${brand}/rule/${ruleId}`;

    return getConfig(body)
        .then((config) => API.put(API_NAME, path, config))
        .then(validateResponse)
        .catch(handleError);
}

export async function updateRuleStatus(country, brand, ruleId, status) {
    const path = `/v1/zerocopycdp/${country}/${brand}/rule/${ruleId}/status`;

    return getConfig({ status })
        .then((config) => API.patch(API_NAME, path, config))
        .then(validateResponse)
        .catch(handleError);
}//mycode

export async function deleteRule(country,brand,ruleId) {
    // const path = `/v1/nbaadmin/${country}/rule/${ruleId}`;
    const path = `/v1/zerocopycdp/${country}/${brand}/rule/${ruleId}`;

    return getConfig()
        .then((config) => API.del(API_NAME, path, config))
        .then(validateResponse)
        .catch(handleError);
}
